import { n as __toESM } from "./chunk-rolldown-runtime.mjs";
import { t as require_util } from "./chunk-util.mjs";
import "./globals.mjs";
import deepEqual from "deep-equal";
//#region src/util.js
var import_util = /* @__PURE__ */ __toESM(require_util(), 1);
var isDeepStrictEqual = (actual, expected) => deepEqual(actual, expected, { strict: true });
var util_default = Object.assign(import_util.default, { isDeepStrictEqual });
//#endregion
var callbackify = import_util.callbackify;
var debuglog = import_util.debuglog;
var format = import_util.format;
var inspect = import_util.inspect;
var promisify = import_util.promisify;
var stripVTControlCharacters = import_util.stripVTControlCharacters;
export { callbackify, debuglog, util_default as default, format, inspect, isDeepStrictEqual, promisify, stripVTControlCharacters };

//# sourceMappingURL=util.mjs.map